<div class="row">
  <div class="col-12 col-md-12 mt-2">
    <app-field [label]="label" [required]="required"
      [validateMessage]="validateMessage"
      [name]="name">
      <app-autocomplete
        [form]="form"
        [name]="key"
        [customClass]="customClass"
        [url]="url"
        [params]="params"
        (onFocusOut)="onFocusOut.emit($event)"
        (onChange)="addChip($event)"
        [fieldName]="fieldName"
        [key]="key"
        [searchFor]="searchFor"
      ></app-autocomplete>
    </app-field>
  </div>
</div>
<div class="row">
  <div class="col-12">
    <div class="divChip">
      <div class="text-white ml-2 mr-2 divCustom" *ngFor="let aee of chipControl?.value || []" style="display: inline-block">
        {{ aee.nome }}
        <em *ngIf="!isOnlyView" class="fas fa-times-circle" id="iconCustom" (click)="removeChip(aee)"></em>
      </div>
    </div>
  </div>
</div>
